import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class PatPointsAwarded extends Fragment {
    constructor() {
        super();
    }

    summarize(summaryContext) {
        const message = `with ${summaryContext?.gameConfig?.scoring?.runPAT} points awarded.`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
